function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "add payment"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45691",
    d: "M95.5 17.5a8 8 0 1 0 4 1.072 8 8 0 0 0-4-1.072zm0 14.933a6.933 6.933 0 1 1 4.9-2.031 6.934 6.934 0 0 1-4.9 2.031z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-87.497 -17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45692",
    d: "M267.833 140.533a.533.533 0 0 0-.533-.533h-4.267a.533.533 0 1 0 0 1.067h1.067a1.6 1.6 0 0 1 1.5 1.067h-2.571a.533.533 0 1 0 0 1.067h2.571a1.6 1.6 0 0 1-1.5 1.067h-1.067a.533.533 0 0 0-.32.96l4.267 3.2a.533.533 0 1 0 .64-.853l-3.045-2.283a2.667 2.667 0 0 0 2.133-2.091h.592a.533.533 0 1 0 0-1.067h-.592a2.666 2.666 0 0 0-.475-1.067h1.067a.533.533 0 0 0 .533-.533z",
    transform: "translate(-257.167 -136.267)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpayment);
export default __webpack_public_path__ + "static/media/addpayment.59c09e8b4bfd7fb21e9219ee02a658b7.svg";
export { ForwardRef as ReactComponent };